exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".end {\n  border-top: 1px solid rgba(0, 0, 0, 0.5); }\n\n.hidden {\n  display: none; }\n\n.showing {\n  display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/danfostersmith/Documents/GitHub/crossing-borders/src/app/text-modal/text-modal.component.scss
// module id = ../../../../../src/app/text-modal/text-modal.component.scss
// module chunks = main